import http from '@/utils/http'
import util from '@/utils/util'
import downloadModuleEnum from '@/utils/enums/downloadModuleEnum'
import exportTypeEnum from '@/utils/enums/exportTypeEnum'
import filterWayEnum from '@/utils/enums/filterWayEnum'
import exportStateEnum from '@/utils/enums/exportStateEnum'

//单科考试 - 质量报告
export const getQualityReport = (params) => http.get('/marking-statistics-report/paper/analysis', params)

//单科考试 - 班级报告 - 知识能力分析
export const classStatCompare = (params) => http.post('/marking-statistics-report/kqa/one/school/admin/class', params)//班级各得分情况对比（弹框）

//单科考试 - 班级报告 - 试卷讲评
export const getPaper = (params) => http.get('/marking-statistics-report/paper/review', params).then(resp => {
  if (resp.body) {
    for (let index = 0; index < resp.body.length; index++) {
      const element = resp.body[index];
      // 后端就是有可能question为空
      element.question = element.question ? element.question : {}
    }
    return { code: 200, result: resp.body }
  }
  return resp
})//获取试卷
export const getError = (params) => http.post('/marking-error-notebook/error_notebook/paper/get_error', params)//获取错题集
export const getAnalysis = (params) => http.post('/marking-report/paper/get_analysis', params)//获取解析
export const updateAnalysis = (params) => http.post('/marking-report/paper/update_analysis', params)//修改解析
export const comparison = (params) => http.get('/marking-statistics-report/paper/class/stand/score/compare', params)//查询题目班级作答对比（图形）
export const questionStatistics = (params) => http.get('/marking-statistics-report/paper/stand/review', params)//查询考试题目解答详细
export const listExamDownload = (params) => http.get('/marking-report/report/listExamDownload', params)//查询试卷讲评下载信息
export const listTeachExamDownload = (params) => http.get('/marking-report/report/teach/listExamDownload', params)//查询试卷讲评下载信息(教学班)
export const exportClassExamPaperInfo = (params) => http.post('/marking-report/report/exportClassExamPaperInfo', params, 'form')//生成试卷讲评excel
export const exportTeachClassExamPaperInfo = (params) => http.post('/marking-report/report/teach/exportClassExamPaperInfo', params, 'form')//生成试卷讲评excel(教学班)
export const setQuestionStick = (params) => http.post('/marking-statistics-report/paper/comment/stand/mark', params, 'form')// 设置讲评题目置顶
export const markPaperDetail = (params) => http.post('/marking-statistics-report/paper/student/comment/stand/mark', params, 'form')// 标记试卷某一题
export const getStudentDetail = (params) => http.get('/marking-report/report/getStudQues', params, 'form')// 获取学生作答

//单科考试 - 班级报告 - 自定义分析
export const classCustClass = (params) => http.get('/marking-report/report/exam/custom/class/analysis', params)//班级自定义分析（班级分析）
export const classCustStudent = (params) => http.get('/marking-report/report/exam/custom/student/analysis', params, 'form')//班级自定义分析（学生分析）

//单科考试 - 校级报告 - 自定义分析
export const getSchoolGroupAnaly = (params) => http.get('/marking-statistics-report/custom/class/group/analysis', params)//获取分组分析数据
export const setSchoolGroup = (params) => http.post('/marking-statistics/exam-config/custom/admin/class/group?examId=' + params.examId + '&schoolId=' + params.schoolId, params.list)//添加分组分析
export const getSchoolAnyExamAnaly = (params) => http.get('/marking-report/report/exam/custom/arbitrarily/analysis', params)//获取任意考试对比数据
export const setSchoolAnyExamAnaly = (params) => http.post('/marking-report/report/exam/custom/arbitrarily/analysis/config', params, 'form')//添加任意考试对比分析

//多科报告 - 班级报告 - 基础成绩分析
export const classMultiIndexanalysis = (params) => http.get('/marking-statistics-report/multiple/basic/index/class/all/subject', params)//查询班级基础指标分析
export const classMultiIndextrend = (params) => http.get('/marking-statistics-report/multiple/basic/index/final/summary/class/index/trend', params)//查询班级基础指标趋势

// 校级报告 单科
export const getGradeKnowledgePointList = (params) => http.get('/marking-report/report/exam/grade/statistics/pointInfo', params) // 年级知识点得分详细
export const classQuesAnalysis = (params) => http.get('/marking-report/report/exam/class/question/analysis', params, 'form') // 班级逐题分析
export const studentQuesAnalysis = (params) => http.get('/marking-report/report/exam/student/question/analysis', params, 'form') // 学生逐题分析

// 题型、知识点、能力相关
export const getPattern = (params) => http.post('/marking-question/public/question/info/list/pattern/by-questIds', params) //获取单个题目题型
export const updatePattern = (params) => http.put('/marking-question/public/question/info/update/pattern/by-id', params, 'form')//修改题目题型

// 学科网 知识点、能力
export const getXkwPointList = (courseId) => http.get('/marking-question/public/question/knowledge-point/courses/' + courseId + '/knowledge-points/tree').then(resp => {
  return pointXkwToYujuan(resp)
})
export const getQuestionXkwPoint = (questionId) => http.get('/marking-question/public/question/knowledge-point', { questionId }).then(resp => {
  return pointXkwToYujuan(resp)
})
export const updateXkwPoint = (params) => http.post('/marking-question/public/question/knowledge-point', params)//更改题目知识点

export const getXkwAbilityList = (courseId) => http.get('/marking-question/public/question/ability/course/ability', { courseId }).then(resp => {
  return abilityXkwToYujuan(resp)
})
export const getQuestionXkwAbility = (questionId) => http.get('/marking-question/public/question/ability/get_que_ab', { questionId })//获取单个题目能力

export const updateXkwAbility = (params) => http.post('/marking-question/public/question/ability', params)//更改题目能力


//导出报表
export const exportClassTable = (params) => http.get('/marking-main/exam/exam/export_analysis_ques_class', params)//导出班级逐题分析
export const exportStudentTable = (params) => http.get('/marking-main/exam/exam/export_analysis_ques_stud', params)//导出学生逐题分析
export const exportCustomContrastTable = (params) => http.get('/marking-main/exam/exam/export_exam_compare', params)//导出任意考试对比
export const exportCustomGroupTable = (params) => http.get('/marking-main/exam/exam/export_group_analysis', params)//导出分组分析
export const exportTranscriptTable = (params) => http.get('/marking-main/exam/exam/export_subject_grade_record', params)//导出单学科年级成绩单


// 导出年级报表
export const getGradeReportExportList = (params) => http.get('/marking-report/report/listExamDownloadFile', params, 'form')// 导出年级报告数据
export const createGradeReportExport = (params) => http.get('/marking-report/report/bulidFile', params, 'form')// 生成导出年级报告数据
export const downloadGradeReportExport = (params) => http.get('/marking-report/report/downloadFile', params, 'form')// 导出导出年级报告数据
export const importResult = (params) => http.get('/marking-report/report/import_result', params, 'form')// 导出导出年级报告数据
export const startBuild = (params) => http.post('/marking-report/report/start_build', params, 'form') // 开始生成
export const getExportClassErrorList = (params) => http.get('/marking-report/paper/get_export_class_error_list', params, 'form')// 获取导出班级错题集


// 举一反三类题部分
export const getExamQuestionList = (params) => http.post('/marking-report/exam/exam/evaluation/info', params, 'form')// 获取考试试题列表
export const getExamTeacherQuestion = (params) => http.get('/marking-question-center/question/define/getExamTeacherQuestion', params, 'form')// 获取设置过的类题
export const getExamStandQuestion = (params) => http.get('/marking-question-center/question/define/getStandTeacherQuestion', params, 'form')// 获取某题设置过的类题
export const parsingHtml = (params) => http.post('/marking-question-center/question/define/parsingHtml', params)// 解析html文本上传题目
export const parsingQuestion = (params) => http.post('/marking-question-center/question/define/parsingQuestion', params)// 解析html文本上传题目
export const parsingDoc = (params) => http.get('/marking-question-center/question/define/parsingDoc', params, 'form')// 上传解析doc
export const deleteStandTeacherQuestion = (params) => http.get('/marking-question-center/question/define/deleteStandTeacherQuestion', params, 'form')// 取消设置为类题


export const getClassErrorExportList = (params) => http.post('/marking-statistics-download/wrong_question/download-task/list', params)   // 班级报告错题导出任务列表
export const createClassErrorExport = (params) => http.post('/marking-statistics-download/wrong_question/save', params)    // 导出班级错题集
export const getExportTaskDetail = (taskId) => http.get('/marking-statistics-download/wrong_question/download-task/detail', { taskId })    // 获取单个导出任务
export const reStudentErrorExport = (taskId) => http.post('/marking-statistics-download/wrong_question/refresh/' + taskId, {})    // 获取单个导出任务
export const getStudentErrorExport = (params) => http.post('/marking-error-notebook/error_notebook/get_student_error_list', params)    // 导出单个学生错题集

// 题组模块
export const getExamQuestionGroupPage = (params) => http.post('/marking-report/question/exam/getExamQuestionGroupPage', params, 'form') // 题组模块列表
export const getExamQuestionGroupDetail = (params) => http.get('/marking-report/question/exam/getExamQuestionGroupDetail', params, 'form') // 添加组合详情
export const setExamStatisticsCustomAnalysisConfig = (params) => http.post('/marking-report/question/exam/setExamStatisticsCustomAnalysisConfig', params, 'form') // 添加组合详情
export const getExamProportionAnalysisConfigDetail = (params) => http.post('/marking-report/question/exam/getExamProportionAnalysisConfigDetail', params, 'form') // 添加组合详情
export const setExamProportionAnalysisConfig = (params) => http.post('/marking-report/question/exam/setExamProportionAnalysisConfig', params, 'form') // 模块比例设置
export const getExamAnalysisConfigDel = (params) => http.post('/marking-report/question/exam/getExamAnalysisConfigDel', params, 'form') // 模块删除
export const analysisClass = (params) => http.get('/marking-report/question/exam/custom/class/analysis', params, 'form') // 班级报告题组模块分析（班级分析）
export const analysisGrade = (params) => http.get('/marking-report/question/exam/custom/grade/analysis', params, 'form') // 年级报告题组模块分析（年级分析）
export const analysisStudent = (params) => http.get('/marking-report/question/exam/custom/student/analysis', params, 'form') // 年级报告题组模块分析（学生分析）
export const listExamDownloadFile = (params) => http.get('/marking-report/report/listExamDownloadFile', params, 'form') // 年级报告题组模块分析（学生分析）
export const listMultipleClassExamDownloadFileV2 = (params) => http.get('/marking-report/report/listClassExamDownloadFileV2', params, 'form') // 班级报告题组模块分析（学生分析）
// 导出原卷

// 获取导出原卷列表
export const getDownHistoryList = (key, params) => http.post(`/marking-statistics-download/${key}/paper/list`, params).then(resp => {
  if (resp.success && resp.body) {
    resp.body.forEach(item => {
      item.filterWay = util.getEnumCodeByKey(filterWayEnum, item.filterWay)
      item.downloadModule = util.getEnumCodeByKey(downloadModuleEnum, item.downloadModule)
      item.isHen = util.getEnumCodeByKey(exportTypeEnum, item.isHen)
      item.state = util.getEnumCodeByKey(exportStateEnum, item.state)
    })
  }

  return resp
})
export const originalExamDownload = (key, params) => http.post(`/marking-statistics-download/${key}/paper/save`, params) // 执行导出原卷
export const getDownHistoryQuestionNum = (params) => http.get('/marking-exam-manager/stand/list-exam-one-exam-two-subjective', params) // 获取题号列表
export const reMarking = (key, params) => http.post(`/marking-statistics-download/${key}/paper/refresh`, params) // 重新打标

export const onlyOriginalExamDownload = (params) => http.post('/marking-download/examReportDownload/onlyOriginalExamDownload', params) // 执行导出原卷-单科
export const anyOriginalExamDownload = (params) => http.post('/marking-download/examReportDownload/anyOriginalExamDownload', params) // 执行导出原卷-多科
export const newHighOriginalExamDown = (params) => http.post('/marking-download/examReportDownload/newHighOriginalExamDown', params) // 执行导出原卷-新高考

export const getDownPaperCount = (params) => http.post('/marking-statistics-download/download-paper/count', params) // 获取试卷下载数量


// 数据处理函数
function pointXkwToYujuan (resp) {
  const yjResp = {
    code: 200,
    message: null,
    result: []
  }
  if (resp.body) {
    for (let index = 0; index < resp.body.length; index++) {
      const element = resp.body[index];
      const target = yjResp.result.find(item => item.id === element.id)
      if (target) continue
      const item = {}
      item.id = element.id
      item.label = element.name
      item.name = element.name
      item.pid = element.parentId
      item.subjectId = -1
      item.children = pointNodeChildren(element)
      yjResp.result.push(item)
    }
  }
  return yjResp
}

function pointNodeChildren (node) {
  let children = null
  if (node.children) {
    children = []
    for (let index = 0; index < node.children.length; index++) {
      const element = node.children[index];
      const item = {}
      item.id = element.id
      item.label = element.name
      item.name = element.name
      item.pid = element.parentId
      item.subjectId = -1
      item.children = pointNodeChildren(element)
      children.push(item)
    }
  }
  return children
}

function abilityXkwToYujuan (resp) {
  const yjResp = {
    code: 200,
    message: null,
    result: { main: [] }
  }
  if (resp.body) {
    for (let index = 0; index < resp.body.length; index++) {
      const element = resp.body[index];
      const item = {}
      item.abilityName = element.name
      item.id = element.id + '' // mdm是整型，这里处理成和阅卷本地一样的字符串
      item.subjectCode = element.courseId
      item.subjectName = element.remark
      yjResp.result.main.push(item)
    }
  }
  return yjResp
}